
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EyeIcon',
  props: {
    eyeType: {
      type: String,
      default: 'on'
    }
  }
});
